import { useRef, useEffect } from 'react';
import {
  TUIChatEngine,
  TUIStore,
  StoreName,
  TUIConversationService,
  IConversationModel,
} from '@tencentcloud/chat-uikit-engine';
import {
  Chat,
  ChatHeader,
  MessageList,
  MessageInput,
  Profile,
  ConversationList,
  ChatSetting,
  VariantType,
  Search,
  useUIOpenControlState,
  useConversationListState,
  useMessageInputState,
} from '@tencentcloud/chat-uikit-react';
import { UIKitProvider } from '@tencentcloud/uikit-base-component-react';
import { TUICallKit } from '@tencentcloud/call-uikit-react';
import cs from 'classnames';
import { useOutlet } from '@/context/OutletContext';
import {Drawer} from '@/components/Drawer';
import { reportEvent, REPORT_KEY } from '@/utils/aegis';

import './InboxWeb.scss';

function InboxWeb() {
  const {
    theme,
    language,
    chat,
  } = useOutlet();

  const {
    isChatSettingOpen,
    setChatSettingOpen,
    isChatSearchOpen,
    setChatSearchOpen,
  }  = useUIOpenControlState();

  const { conversationList, setActiveConversation } = useConversationListState();

  const { sendMessage } = useMessageInputState();

  useEffect(() => {
    if (conversationList && conversationList.length > 0) {
      setActiveConversation('C2CRobot11');
    }
  }, []);

  // const callButtonClicked = (callMediaType?: number) => {
  //   if (callMediaType === 2) {
  //     reportEvent({ actionKey: REPORT_KEY.VIDEO_CALL, loginUserID });
  //   } else {
  //     reportEvent({ actionKey: REPORT_KEY.AUDIO_CALL, loginUserID });
  //   }
  // };

  const callStyle: React.CSSProperties = {
    position: 'fixed',
    width: '800px',
    top: '50%',
    left: '50%',
    zIndex: '999',
    transform: 'translate(-50%, -50%)',
  };

  return (
    <div className={cs('web-container', theme)} style={{ position: 'relative', overflow: 'hidden' }}>
      <UIKitProvider chat={chat} language={language} theme={theme}>
        <TUICallKit style={callStyle} />
        <div className="sample-chat-left-container">
          <Profile />
          <ConversationList />
        </div>
        <Chat>
          <ChatHeader chatHeaderActions={['videoCall', 'audioCall', 'search', 'chatSetting']}/>
          <MessageList />
          <MessageInput />
          <Drawer
            open={isChatSettingOpen}
            onClose={() => setChatSettingOpen(false)}
            container={null}
            anchor="right"
            size={360}
          >
            <ChatSetting />
          </Drawer>
          <Drawer
            open={isChatSearchOpen}
            onClose={() => setChatSearchOpen(false)}
            container={null}
            anchor="right"
            size={360}
          >
            <Search variant={VariantType.EMBEDDED} />
          </Drawer>
        </Chat>
      </UIKitProvider>
    </div>
  );
}

export default InboxWeb;
